<template>
	<div>
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%">
			<el-dialog title="角色管理" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">

				<canvas id="mycanvas" width="600" height="400"></canvas>

			</el-dialog>
		</el-form>
		<!--弹出框-->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: true,
				ruleForm: {

				},
				rules: {

				},

			}
		},
		mounted() {
			this.myCanvas()
		},
		methods: {
			handleClose() {
				this.dialogVisible = false;
				this.$emit("adddata", {
					dialogVisible: this.dialogVisible
				});
			},

		

			myCanvas() {

				this.$nextTick(function() {
					let canvas = document.getElementById('mycanvas')
					let context = canvas.getContext('2d')
				
					
					context.beginPath()
					context.moveTo(50,50)
					
					context.lineTo(50,350);
					
					context.lineTo(280,350);
					
					context.strokeStyle = '#fff';
					context.lineWidth = 2;
				
					context.fillStyle="#0d97e2"
					context.fillRect(50,170,500,180)
					context.stroke();
					
					context.beginPath()
					context.moveTo(550,50)
					//context.arcTo(500,50,500,150,30)
					
					context.arcTo(500,150,400,150,20)
					//context.arcTo(400,150,400,50,10)
					context.arcTo(500,50,500,50,0)
					
					context.stroke();
					
					/*context.beginPath()
					context.lineTo(550,50);
					context.lineTo(550,350);
					context.strokeStyle = 'red';
					context.lineWidth = 1;
					context.fillStyle="#ccc"
					context.fillRect(280,50,270,300)
					context.stroke();	
					context.beginPath()
					context.moveTo(500,50)
					context.quadraticCurveTo(440,280,280,350,550,50)
					context.stroke();*/
					
					
				})

				

			}
		},
		
	}
</script>

<style scoped>
	>>>.el-dialog {
		width: 700px;
	}
	
	>>>.el-dialog__body {
		height: 500px;
		overflow: auto;
		background: #717171;
	}
	
	#mycanvas {
		border: 1px solid #ccc;
	}
</style>